import ProductCard from "@components/ProductCard/ProductCard";
import Feed from "@models/feed";
import React, { useRef, useState, useEffect } from "react";
import styles from "./ProductsRail.module.scss";

interface ProductsRailProps {
  feed: Feed;
  className?: string;
}

const ProductsRail: React.FC<ProductsRailProps> = ({ feed, className }) => {
  const ref = useRef<HTMLDivElement>(null!);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  const scrollLeft = () => {
    if (ref.current) {
      ref.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (ref.current) {
      ref.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const updateArrows = () => {
    const el = ref.current;
    if (!el) return;
    setShowLeftArrow(el.scrollLeft > 0);
    setShowRightArrow(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const handleScroll = () => updateArrows();
    updateArrows();
    el.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    return () => {
      el.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  // Generate a slug-friendly ID from the feed title or use feed.id as fallback
  const sectionId = React.useMemo(() => {
    if (feed.title) {
      const slug = feed.title
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '') // Remove special characters
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/-+/g, '-'); // Replace multiple hyphens with single hyphen
      if (slug) return `collection-${slug}`;
    }
    return `collection-${feed.id}`;
  }, [feed.title, feed.id]);

  return (
    <section id={sectionId} className={`${styles["portrait-section"]} position-relative ${className || ''}`}>
      <div className={styles["main-heading"]}>{feed.title}</div>
      <div className={styles["portrait-games-list"]} ref={ref}>
        {feed.items.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
      {
        showLeftArrow &&
        <button className={ styles["arrowPaddingLeft"] + " position-absolute pr-4 is-hidden-touch" }
        onClick={() => scrollLeft()}>
          <img className={"position-absolute"} style={{ left: "15px" }}
            src={`${process.env.PUBLIC_URL}/images/logos/arrow-left.svg`}
            height="30" alt="Scroll Left" />
        </button>
      }
      {
        showRightArrow && 
        <button className={ styles["arrowPaddingright"] + " position-absolute pl-4 is-hidden-touch" }
        onClick={() => scrollRight()}>
          <img className={"position-absolute"} style={{ right: "15px" }}
            src={`${process.env.PUBLIC_URL}/images/logos/arrow-right.svg`}
            height="30" alt="Scroll Right"/>
        </button>
      }
    </section>
  );
};

export default ProductsRail;
